import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  Outlet,
  useMatch,
  matchPath,
  useResolvedPath,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { Form } from 'react-bootstrap';

const NAV_ITEMS = [
  { path: '/portal/storage/inventory', label: 'Inventory' },
  { path: '/portal/storage/pick-lists', label: 'Pick Lists' },
  { path: '/portal/storage/documents', label: 'Documents' },
  { path: '/portal/storage/payments', label: 'Payments' },
];

function Storage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileNavActiveItem, setMobileNavActiveItem] = useState('');

  const handleMobileNavChange = (e) => {
    navigate(e.target.value);
  };

  useEffect(() => {
    const matchedNavItem = NAV_ITEMS.find(({ path }) =>
      matchPath({ path, caseSensitive: true, end: false }, location.pathname)
    );

    if (matchedNavItem) {
      setMobileNavActiveItem(matchedNavItem.path);
    }
  }, [location]);

  return (
    <div>
      <header className="portal-header">
        <h1>Storage</h1>

        <nav className="portal-tabs">
          <ul className="d-none d-md-flex">
            {NAV_ITEMS.map(({ path, label }) => (
              <TabLink to={path} key={path}>
                {label}
              </TabLink>
            ))}
          </ul>
          <div className="d-md-none d-sm-block">
            <Form.Select
              onChange={handleMobileNavChange}
              value={mobileNavActiveItem}
            >
              {NAV_ITEMS.map(({ path, label }) => (
                <option value={path} key={path}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </div>
        </nav>
      </header>
      <Outlet />
    </div>
  );
}

function TabLink({ to, children, ...props }) {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false });
  return (
    <li className={match ? 'active' : ''}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  );
}

TabLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Storage;
